/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RequestScaleValueResponse } from '../../models/request-scale-value-response';

export interface RequestScaleValue$Params {
  workCenterId: number;
}

export function requestScaleValue(http: HttpClient, rootUrl: string, params: RequestScaleValue$Params, context?: HttpContext): Observable<StrictHttpResponse<RequestScaleValueResponse>> {
  const rb = new RequestBuilder(rootUrl, requestScaleValue.PATH, 'post');
  if (params) {
    rb.path('workCenterId', params.workCenterId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RequestScaleValueResponse>;
    })
  );
}

requestScaleValue.PATH = '/api/v1/Measurement/{workCenterId}/RequestScaleValue';
